/// <reference types="@angular/localize" />

import { enableProdMode, isDevMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// Initialize Sentry before Angular bootstrap
const sentryConfig = environment.sentry;

// Only enable Sentry when not running in dev mode to avoid noisy local error reports
if (!isDevMode() && sentryConfig?.enabled && sentryConfig.dsn) {
  const integrations = [];

  const sessionSampleRate = sentryConfig.replaysSessionSampleRate ?? 0;
  const onErrorSampleRate = sentryConfig.replaysOnErrorSampleRate ?? 0;

  // Add Session Replay integration if sampling is configured
  if (sessionSampleRate > 0 || onErrorSampleRate > 0) {
    integrations.push(
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      })
    );
  }

  // Add Feedback widget integration (replaces marker.io)
  if (
    sentryConfig.feedbackEnabled &&
    typeof Sentry.feedbackIntegration === "function"
  ) {
    integrations.push(
      Sentry.feedbackIntegration({
        colorScheme: "system",
        autoInject: true,
        enableScreenshot: true,
        triggerLabel: "Feedback",
        triggerAriaLabel: "Feedback openen",
        formTitle: "Meld een probleem of idee",
        submitButtonLabel: "Verstuur",
        cancelButtonLabel: "Annuleren",
        messageLabel: "Beschrijving",
        messagePlaceholder: "Beschrijf wat er gebeurde of wat je verwachtte.",
        nameLabel: "Naam",
        namePlaceholder: "Jouw naam",
        emailLabel: "E-mailadres",
        emailPlaceholder: "naam@bedrijf.nl",
        successMessageText: "Bedankt voor je feedback!",
        isRequiredLabel: "(verplicht)",
        addScreenshotButtonLabel: "Screenshot toevoegen",
        removeScreenshotButtonLabel: "Screenshot verwijderen",
        useSentryUser: {
          email: "email",
          name: "username",
        },
      })
    );
  }

  // Note: release is read automatically from window.SENTRY_RELEASE.id (set in index.html)
  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
    sendDefaultPii: sentryConfig.sendDefaultPii,
    tracesSampleRate: sentryConfig.tracesSampleRate,
    replaysSessionSampleRate: sessionSampleRate,
    replaysOnErrorSampleRate: onErrorSampleRate,
    integrations,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
